import { lang, setLang } from '../lib/i18n';
import { tenant } from '../lib/tenant';

const LABELS: Record<string, string> = { en: 'EN', hi: 'हिं' };

/** EN | हिं — switches the whole app's language (persisted to localStorage). */
export function LanguageSwitch() {
  return (
    <div class="c-lang-switch" role="group" aria-label="Language">
      {tenant.product.languages.map((code) => (
        <button
          key={code}
          type="button"
          class="c-lang-switch__opt"
          aria-pressed={lang.value === code}
          onClick={() => setLang(code)}
        >
          {LABELS[code] ?? code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
